import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  // Used for managing keyboard navigation with a search input and a list of items (e.g., in a combobox)
  connect() {
    this.activeIndex = this.items.length ? 0 : -1
    this.updateActiveClasses()
  }

  handleKeydown(event) {
    const key = event.key

    if (key === "ArrowDown") {
      event.preventDefault()
      this.focusNext()
      return
    }

    if (key === "ArrowUp") {
      event.preventDefault()
      this.focusPrevious()
      return
    }

    if (key === "Enter") {
      if (this.focusedItem) {
        event.preventDefault()
        this.focusedItem.click()
      }
      return
    }

    this.focusInput()
  }

  itemTargetConnected(element) {
    this.resetActiveIndex()
  }

  itemTargetDisconnected(element) {
    this.resetActiveIndex()
  }
  resetActiveIndex() {
    this.activeIndex = this.items.length ? 0 : -1
    this.updateActiveClasses()
  }

  handleFocus(event) {
    const index = this.items.indexOf(event.target)
    if (index >= 0) this.setActiveIndex(index)
  }

  focusNext() {
    const nextIndex = Math.min(this.items.length - 1, this.currentIndex + 1)
    this.focusItem(nextIndex >= 0 ? nextIndex : 0)
  }

  focusPrevious() {
    if (this.currentIndex <= 0) {
      this.focusInput()
      return
    }
    this.focusItem(this.currentIndex - 1)
  }

  focusItem(index) {
    const item = this.items[index]
    if (!item) return

    this.setActiveIndex(index)
  }

  focusInput() {
    this.clearActive()
    if (this.hasInputTarget) this.inputTarget.focus({ preventScroll: true })
  }

  setActiveIndex(index) {
    this.activeIndex = index
    this.updateActiveClasses()
  }

  clearActive() {
    this.activeIndex = -1
    this.updateActiveClasses()
  }

  updateActiveClasses() {
    this.items.forEach((item, idx) => {
      const parent = item.closest(".list-group-item-action")
      if (!parent) return

      parent.classList.toggle("keyboard-hover", idx === this.activeIndex)
    })
  }

  get items() {
    return this.itemTargets
  }

  get currentIndex() {
    if (this.activeIndex >= 0) return this.activeIndex
    return this.items.indexOf(document.activeElement)
  }

  get focusedItem() {
    const idx = this.currentIndex
    return idx >= 0 ? this.items[idx] : null
  }
}
